import Field from '@base/Form/Field';
import ReferralCodeInput from '@cont/Checkout/ReferralCodeInput';
import { useState } from 'react';
import styled from '@emotion/styled';
import { Spacings, Fonts, mediaQuery } from '@styles/index';
import fetch from '@api/fetchers';
import {
  FormContainer,
  FormSectionHeading,
  FieldWrapper,
  Error,
  StyledDropdown,
  ExtraFieldsHR,
  ExtraFieldsHeading,
  ReferralFieldWrapper
} from './styles';
import { isRequired } from './utils';
import { getIsReferralValid } from '../apiHelper';

const StyledP2 = styled.p`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.P2};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: ${({ color }) => color};
  margin-top: ${Spacings.SPACING_2B};
  margin-left: ${Spacings.SPACING_10B};
  ${mediaQuery.uptoTablet} {
    margin-left: 30px;
  }
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.EXTRA_SMALL};
  }
`;
const renderErrorMessage = ({ message }) => {
  return <Error>{message}</Error>;
};

const GoalDetails = ({
  registrar,
  fields,
  knowAbout,
  showExtraFields,
  isReferralPreapplied = true,
  referralInputRef
}) => {
  const goalDetailsKeys = Object.keys(fields ?? {});
  const goalKey = goalDetailsKeys.find((key) => key === 'Goal');
  const centreKey = goalDetailsKeys.find((key) => key === 'Centre');

  const [referral, setReferralCode] = useState(null);
  const [referralSubmitted, setReferralSubmitted] = useState(false);
  const [isReferralValid, setIsReferralValid] = useState(false);
  const [referralMessage, setReferralMessage] = useState('');
  return (
    <FormContainer>
      {goalDetailsKeys?.length ? (
        <>
          {showExtraFields ? (
            <>
              <FormSectionHeading>Goal details</FormSectionHeading>
              {goalDetailsKeys.map((testDetailsKey, index) => {
                if (!fields[testDetailsKey].isHidden) {
                  return (
                    <FieldWrapper key={String(index)}>
                      <Field
                        registrar={registrar}
                        name={testDetailsKey}
                        rules={
                          testDetailsKey !== 'Year'
                            ? [isRequired(`${testDetailsKey} is required`)]
                            : []
                        }
                        render={({ onChange, value }) => (
                          <StyledDropdown
                            options={fields[testDetailsKey].options}
                            placeholder={fields[testDetailsKey].placeholder}
                            selectedOption={value}
                            onOptionClick={(data) => onChange(data)}
                            buttonWidth="100%"
                            menuWidth="320px"
                          />
                        )}
                        renderError={renderErrorMessage}
                      />
                    </FieldWrapper>
                  );
                }
                return null;
              })}
              <ExtraFieldsHR />
              <ExtraFieldsHeading>
                How did you get to know about Unacademy?
              </ExtraFieldsHeading>
              <FieldWrapper>
                <Field
                  registrar={registrar}
                  name="about"
                  render={({ onChange, value }) => (
                    <StyledDropdown
                      options={knowAbout}
                      placeholder="Select your answer"
                      selectedOption={value}
                      onOptionClick={(data) => onChange(data)}
                      buttonWidth="100%"
                      menuWidth="320px"
                    />
                  )}
                  renderError={renderErrorMessage}
                />
              </FieldWrapper>
              <FieldWrapper>
                <Field
                  registrar={registrar}
                  name="referral"
                  render={({ onChange }) => {
                    const onApplyReferral = async (referralCode) => {
                      setReferralCode(referralCode);
                      onChange(referralCode);
                      const goalUID = registrar.data?.Goal?.value;
                      if (goalUID) {
                        const response = await fetch(
                          getIsReferralValid(referralCode, goalUID)
                        );

                        setIsReferralValid(response.isValid); // according to is_Valid;
                        setReferralMessage(response.message); // according to the message;
                        setReferralSubmitted(true);
                      } else {
                        setIsReferralValid(false); // according to is_Valid;
                        setReferralMessage('Please select your goal first');
                      }
                    };
                    const resetReferralCode = () => {
                      setReferralCode(null);
                      setReferralSubmitted(false);
                      setIsReferralValid(false);
                      setReferralMessage('');
                      onChange(null);
                    };
                    return (
                      <>
                        <ReferralFieldWrapper>
                          <ReferralCodeInput
                            error={referralSubmitted && !isReferralValid}
                            color={
                              referralSubmitted && isReferralValid
                                ? 'secondary'
                                : 'primary'
                            }
                            onApply={onApplyReferral}
                            resetReferral={resetReferralCode}
                            referralSubmitted={referralSubmitted}
                            defaultValue={
                              isReferralPreapplied ? referral : null
                            }
                            // @ts-ignore
                            ref={referralInputRef}
                            textFieldCustomWidth="100%"
                          />
                        </ReferralFieldWrapper>

                        {referral && referralMessage !== '' ? (
                          <StyledP2
                            color={
                              isReferralValid
                                ? 'var(--color-i-green)'
                                : 'var(--color-i-red)'
                            }
                            role={
                              isReferralValid
                                ? 'referral-message-valid'
                                : 'referral-message-invalid'
                            }
                          >
                            {referralMessage}
                          </StyledP2>
                        ) : null}
                      </>
                    );
                  }}
                />
              </FieldWrapper>
            </>
          ) : (
            <>
              {goalKey && (
                <FieldWrapper>
                  <Field
                    registrar={registrar}
                    name={goalKey}
                    rules={[isRequired(`${goalKey} is required`)]}
                    render={({ onChange, value }) => (
                      <StyledDropdown
                        options={fields[goalKey].options}
                        placeholder={fields[goalKey].placeholder}
                        selectedOption={value}
                        onOptionClick={(data) => onChange(data)}
                        buttonWidth="100%"
                        menuWidth="320px"
                      />
                    )}
                    renderError={renderErrorMessage}
                  />
                </FieldWrapper>
              )}
              <FieldWrapper>
                <Field
                  registrar={registrar}
                  name={centreKey}
                  rules={[isRequired(`${centreKey} is required`)]}
                  render={({ onChange, value }) => (
                    <StyledDropdown
                      options={fields[centreKey].options}
                      placeholder={fields[centreKey].placeholder}
                      selectedOption={value}
                      onOptionClick={(data) => onChange(data)}
                      buttonWidth="100%"
                      menuWidth="320px"
                    />
                  )}
                  renderError={renderErrorMessage}
                />
              </FieldWrapper>
            </>
          )}
        </>
      ) : null}
    </FormContainer>
  );
};

export default GoalDetails;
